// extracted by mini-css-extract-plugin
export default {"input":"inputAutoSize_input__XIY16","disabled":"inputAutoSize_disabled__qgBKe"};